import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../utils/reducers/company/employees'
import ModalCreateCustomerB2B from './ModalCreateCustomerB2B'
import TableCustomersB2B from '../../../../../../specificComponents/Customers/TableCustomersB2B'
import { connect } from 'react-redux'
import { customerTypes, CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import RightHeaderTableCustomers from '../../../../../../specificComponents/Customers/RightHeaderTableCustomers'


interface CustomersB2BProps extends ComponentWithPermissions { }

const CustomersB2B: React.FC<CustomersB2BProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const pageData = {
        title: t('customersB2B', 'Clientes B2B'),
        newText: t('newCustomerB2B', 'Nuevo cliente B2B'),
    }
    return (
        <BaseScreenTableSimpleStateless TableComponent={TableCustomersB2BConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateCustomerB2B} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderTableCustomers typeCustomer={customerTypes['B2B'] as CustomerTypesInversedKeys}  {...{ pageData, openModal, setOpenModal, userPermissions, updateTableInstance }} />}
        />
    )
}

const tableCustomersB2BDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}


const mapTableCustomersB2BConnector = (state: AllReduxPayloads) => ({ employees: state.employees})
const tableCustomersB2BConnect = connect(mapTableCustomersB2BConnector, tableCustomersB2BDispatch)
const tableCustomersB2BLoading = withLoading(TableCustomersB2B, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const TableCustomersB2BConnect = tableCustomersB2BConnect(tableCustomersB2BLoading)
export default CustomersB2B